var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/field/email"),React.createElement("g",{"id":"icons/field/email","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("polygon",{"id":"Stroke-1","stroke":"#5B00DB","points":"1 12.3333333 15 12.3333333 15 3 1 3","key":0}),React.createElement("polyline",{"id":"Stroke-3","stroke":"#5B00DB","points":"1 3 8 9.38843333 15 3","key":1})])]);
}

Email.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = Email;

Email.default = Email;
